module.exports = __webpack_public_path__ + "static/page_background-7872099a9928e3a7e439b1ea197141e9.png";